<template>
  <div class="value_your_trade_info ai_bg_card bg-white shadow-sm  rounded_10 mb-4" v-if="kbbDetails">
    <div class="row">
      <div class="col-md-12">
        <h1 class="_theme_font_bold font-weight-bold mb-4">{{ vehicleDisplayName }}</h1>
      </div>
    </div>
    <div class="d-flex gap_60 ">
      <div>
        <div class="value_your_trade_info_details position-relative">
          <div class="d-flex justify-content-between">
            <p>Estimated Mileage</p>
            <p class="font-weight-bold _theme_font_bold">{{ kbbDetails.estimated_Mileage }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p>Condition</p>
            <p class="font-weight-bold _theme_font_bold">{{ kbbDetails.condition }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p>Trade-in Value</p>
            <p class="font-weight-bold _theme_font_bold">${{ kbbDetails.selectedValue }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p>High</p>
            <p class="font-weight-bold _theme_font_bold">${{ kbbDetails.high }}</p>
          </div>
          <div class="d-flex justify-content-between">
            <p>Low</p>
            <p class="font-weight-bold _theme_font_bold">${{ kbbDetails.low }}</p>
          </div>
        </div>
      </div>

      <div class="value_your_trade_graphic position-relative bg-white  rounded_10 shadow-sm p-3  ai_new_design">
        <div class="iframe_box">
          <iframe :src="kbbDetails.uri" frameborder="0" title="IFrame Trade Valuation" />
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  props: {
    responseData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    kbbDetails: function () {
      return this.responseData;
    },
    vehicleDisplayName() {
      if (!this.kbbDetails) {
        return "";
      }
      const { year, make, model, trim } = this.kbbDetails;
      return [year, make, model, trim].filter(Boolean).join(" ");
    },
  },
};
</script>

<style lang="less" scoped>
.value_your_trade_info {
  max-width: fit-content;
  padding: 30px;
}

.value_your_trade_info_details {
  min-width: 300px;

  p {
    margin-bottom: 0;
    padding: 15px 0;
  }
}

.gap_60 {
  gap: 60px;
}

.value_your_trade_graphic {

  .iframe_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0 0 0;
    height: 400px;
  }

  iframe {
    height: 100%;
    display: block;
    margin: auto;
  }
}
</style>
